/* unplugin-vue-components disabled */import { render } from "./GridsListing.vue?vue&type=template&id=23c4710d&ts=true"
import script from "./GridsListing.vue?vue&type=script&lang=ts"
export * from "./GridsListing.vue?vue&type=script&lang=ts"

import "./GridsListing.vue?vue&type=style&index=0&id=23c4710d&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__